import React, { useCallback, useState } from 'react';
import { Button } from 'src/@vymo/ui/atoms';
import { Keys, locale } from 'src/i18n';
import { CommitData } from '../types';
import { COMMIT_SIZE_INCREMENT, COMMIT_SIZE_INITIAL } from './constants';
import { formatIsoDate } from './queries';
import styles from './index.module.scss';

export function CommitList({ commits }: { commits: CommitData[] }) {
  const [visibleCommitCount, setVisibleCommitCount] =
    useState(COMMIT_SIZE_INITIAL);

  const handleShowMore = useCallback(() => {
    setVisibleCommitCount((prev) =>
      Math.min(prev + COMMIT_SIZE_INCREMENT, commits.length),
    );
  }, [commits.length]);

  const visibleCommits = commits.slice(0, visibleCommitCount);
  const hasMore = visibleCommitCount < commits.length;
  return (
    <>
      {visibleCommits.map((commit) => (
        <div
          className={styles.releaseBranchHistory__item__content__commit_info}
        >
          <Button
            type="link"
            onClick={() => window.open(commit.jiraTicket, '_blank')}
            className={
              styles.releaseBranchHistory__item__content__commit_info__title
            }
          >
            {commit.prTitle}
          </Button>

          <div
            className={
              styles.releaseBranchHistory__item__content__commit_info__content
            }
          >
            <Button
              type="link"
              onClick={() => window.open(commit.prUrl, '_blank')}
              className={
                styles.releaseBranchHistory__item__content__commit_info__content__pr
              }
            >
              {locale(Keys.PR)}
            </Button>

            <span
              className={
                styles.releaseBranchHistory__item__content__commit_info__content__date
              }
            >
              {formatIsoDate(commit.date, 'MMM d, yyyy')}
            </span>
          </div>
        </div>
      ))}

      {hasMore && (
        <div
          className={`${styles.releaseBranchHistory__item__content__show_more_btn_container}`}
        >
          <Button type="link" variant="subtle" onClick={handleShowMore}>
            {locale(Keys.SHOW_MORE)}
          </Button>
        </div>
      )}
    </>
  );
}
